<template>
  <article class="article-post px-md-9 px-0 pt-9">
    <div v-if="isJsonContent" class="article-post__content-json" itemprop="articleBody">
      <contentBlock
        v-for="(block, i) in dataContent"
        :key="block.type + i"
        :block="block"
        @openImageModal="img => openImageModal(img)"
      />
    </div>
    <div v-else class="article-post__content" v-html="dataContent" itemprop="articleBody"></div>
    <bim-popup
      v-model="modal.image.show"
      @close="modal.image.show = false"
      width="auto"
      closeOnWrapper
    >
      <img
        ref="modalImage"
        class="image-modal__image"
        :src="modal.image.src"
        alt=""
        height="auto"
        widht="atuo"
      />
    </bim-popup>
  </article>
</template>

<script>
import contentBlock from './ContentBlock'
import bimPopup from "@bimlib/components/bimPopup";
import preloader from "@/athoms/preloader"

import breakpoint from "@/mixins/breakpoint.js"

export default {
  components: {
    contentBlock,
    bimPopup,
    preloader
  },
  mixins: [breakpoint],
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isJsonContent: false,
      modal: {
        image: {
          show: false,
          src: ""
        }
      }
    }
  },
  methods: {
    openImageModal(image) {
      this.modal.image.show = true;
      this.modal.image.src = image;
    }
  },
  computed: {
    /**
     * Вычисляет старый контент или новый.
     * В блоке try пытается распарсить полученное поле в JSON. Если не получается, уходит в catch и возвращает другое поле
     */
    dataContent() {
      try {
        const content = JSON.parse(this.data.detail_text)
        this.isJsonContent = true
        return content.blocks
      } catch (e) {
        this.isJsonContent = false
        return this.data.detail_text
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
